var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"study-experience coming-soon"},[_c(_setup.PageHeader,{staticStyle:{"margin-bottom":"20px"},attrs:{"title":"我的学习心得"}}),_c('div',{staticClass:"options"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("新增")])],1),_c('ming-table',{attrs:{"fields":_setup.column,"data":_setup.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }